<template>
  <div class="pr-card-page">
    <h1>枫叶卡及入籍</h1>

    <div class="card-container">
      <div class="main-card" @click="$router.push('/prcard/application')">
        <div class="card-header">
          <h2>枫叶卡申请及换新</h2>
        </div>
        <div class="card-content">
          <p>枫叶卡PR Card 又称为加拿大永久居民卡（Canada Permanent Resident Card），是加拿大永久居民的官方身份证明文件。枫叶卡的有效期为五年。如果卡过期、遗失、损坏或者需要，必须申请新卡。加拿大移民局规定，持卡人必须履行在加拿大的居住义务（Residency Obligation）。</p>
          <div class="requirements">
            <h3>申请要求：</h3>
            <ul>
              <li>必须是加拿大永久居民</li>
              <li>需要提供个人身份证明文件</li>
              <li>提供居住地址证明</li>
              <li>提供照片（符合官方要求）</li>
              <li>支付申请费用</li>
            </ul>
          </div>
        </div>
      </div>

      <div class="citizenship-card" @click="$router.push('/prcard/citizenship')">
        <div class="card-header">
          <h2>入籍申请</h2>
        </div>
        <div class="card-content">
          <p>加拿大入籍申请在满足一定居住年限后，永久居民就可以申请入籍加拿大。按照加拿大法规，成为加拿大公民的过程，入籍成为加拿大公民后，即享有公民的权利。无需更新枫叶卡或申请枫叶卡更新的居住时间。也可享受加拿大护照带来的旅行便利。</p>
          
          <div class="requirements">
            <h3>申请条件：</h3>
            <ul>
              <li>申请人年满18岁以上（18岁以下儿童需要由父母或法定监护人代为申请）</li>
              <li>申请人必须是加拿大永久居民</li>
              <li>在过去5年内，在加拿大实际居住满3年（1095天）</li>
              <li>必须申报个人收入税（如有需要）</li>
              <li>通过入籍考试</li>
              <li>证明语言能力（英语或法语）</li>
              <li>无严重犯罪记录</li>
            </ul>
          </div>

          <div class="exam-content">
            <h3>入籍考试内容：</h3>
            <ul>
              <li>加拿大历史</li>
              <li>加拿大地理</li>
              <li>加拿大政治制度</li>
              <li>公民权利与义务</li>
              <li>加拿大标志和象征</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PRCardView'
}
</script>

<style lang="less" scoped>
.pr-card-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;

  h1 {
    text-align: center;
    color: #333;
    margin-bottom: 40px;
    font-size: 32px;
  }

  .card-container {
    display: flex;
    flex-direction: column;
    gap: 30px;
  }

  .main-card,
  .citizenship-card {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    overflow: hidden;

    .card-header {
      background: #e60012;
      padding: 20px 30px;

      h2 {
        color: #fff;
        margin: 0;
        font-size: 24px;
      }
    }

    .card-content {
      padding: 30px;

      p {
        color: #666;
        line-height: 1.8;
        margin-bottom: 25px;
        font-size: 16px;
      }

      .requirements,
      .exam-content {
        margin-top: 20px;

        h3 {
          color: #e60012;
          margin-bottom: 15px;
          font-size: 20px;
        }

        ul {
          list-style: none;
          padding: 0;
          margin: 0;

          li {
            position: relative;
            padding-left: 24px;
            margin-bottom: 12px;
            color: #666;
            line-height: 1.6;

            &:before {
              content: '';
              position: absolute;
              left: 0;
              top: 8px;
              width: 8px;
              height: 8px;
              background: #e60012;
              border-radius: 50%;
            }
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    padding: 15px;

    h1 {
      font-size: 28px;
      margin-bottom: 30px;
    }

    .main-card,
    .citizenship-card {
      .card-header {
        padding: 15px 20px;

        h2 {
          font-size: 20px;
        }
      }

      .card-content {
        padding: 20px;

        p {
          font-size: 14px;
        }

        .requirements,
        .exam-content {
          h3 {
            font-size: 18px;
          }

          li {
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>